module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.editReportModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Edit " + _vm.editReportModel.reportName,
      "backdrop": false,
      "size": "lg"
    },
    model: {
      value: (_vm.showReportEditor),
      callback: function($$v) {
        _vm.showReportEditor = $$v
      },
      expression: "showReportEditor"
    }
  }, [_c('report-editor-dialog', {
    attrs: {
      "value": _vm.editReportModel,
      "reportServices": _vm.reportServices,
      "modelServices": _vm.modelServices
    },
    on: {
      "dialogClosed": _vm.onReportEditorClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editReportFolderModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Edit " + _vm.editReportFolderModel.name,
      "backdrop": false
    },
    model: {
      value: (_vm.showReportFolderEditor),
      callback: function($$v) {
        _vm.showReportFolderEditor = $$v
      },
      expression: "showReportFolderEditor"
    }
  }, [_c('report-folder-editor-dialog', {
    attrs: {
      "value": _vm.editReportFolderModel,
      "reportServices": _vm.reportServices,
      "modelServices": _vm.modelServices
    },
    on: {
      "dialogClosed": _vm.onReportFolderDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.downloadReportsModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Download Reports",
      "backdrop": false,
      "size": "sm"
    },
    model: {
      value: (_vm.showDownloadReportsDialog),
      callback: function($$v) {
        _vm.showDownloadReportsDialog = $$v
      },
      expression: "showDownloadReportsDialog"
    }
  }, [_c('download-reports-dialog', {
    attrs: {
      "value": _vm.downloadReportsModel,
      "reportServices": _vm.reportServices,
      "modelServices": _vm.modelServices
    },
    on: {
      "dialogClosed": _vm.onDownloadReportsDialogClosed
    }
  })], 1) : _vm._e(), _vm._v(" "), (false) ? _c('div', [(_vm.publishToDashboardModel) ? _c('uiv-modal', {
    attrs: {
      "footer": false,
      "title": "Publish " + _vm.publishToDashboardModel.resultType + " to Dashboard",
      "backdrop": false
    },
    model: {
      value: (_vm.showPublishToDashboardDialog),
      callback: function($$v) {
        _vm.showPublishToDashboardDialog = $$v
      },
      expression: "showPublishToDashboardDialog"
    }
  }, [_c('publish-to-dashboard-dialog', {
    attrs: {
      "value": _vm.publishToDashboardModel
    },
    on: {
      "dialogClosed": _vm.onDownloadReportsDialogClosed
    }
  }, [_vm._v("\n            @dialogClosed=\"onPublishToDashboardDialogClosed\">\n            >\n        ")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    attrs: {
      "id": "treeButtonsDiv"
    }
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "addSectorButton",
      "data-toggle": "tooltip",
      "title": "New folder"
    },
    on: {
      "click": _vm.addScriptButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-folder"
  }), _vm._v("\n                        New folder\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "addReportButton",
      "data-toggle": "tooltip",
      "title": "New report"
    },
    on: {
      "click": _vm.addReportButtonClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v("\n                        New Report\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.getActiveNode() === null
    },
    on: {
      "click": _vm.renameNodeButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Rename\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "disabled": _vm.getActiveNode() === null,
      "data-toggle": "tooltip",
      "title": 'Edit ' + _vm.getActiveNodeName()
    },
    on: {
      "click": _vm.editNodePropertiesButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-edit"
  }), _vm._v(" " + _vm._s("Edit " + _vm.getActiveNodeType()) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "deleteSectorButton",
      "data-toggle": "tooltip",
      "title": "Delete selected nodes in tree"
    },
    on: {
      "click": _vm.deleteSelectionButtonClick
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove"
  }), _vm._v(" Delete\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "downloadReportsAsExcelButton",
      "data-toggle": "tooltip",
      "title": "Download selected reports"
    },
    on: {
      "click": _vm.downloadSelectedReportsAsExcelClick
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "cutSelectedTreeNodesButton",
      "data-toggle": "tooltip",
      "title": "Cut selected nodes to clipboard (Ctrl-v on target node to paste)"
    },
    on: {
      "click": _vm.cutSelectedTreeNodesButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-cut"
  }), _vm._v(" Cut\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "copySelectedTreeNodesButton",
      "data-toggle": "tooltip",
      "title": "Copy selected nodes to clipboard (Ctrl-v on target node to paste)"
    },
    on: {
      "click": _vm.copySelectedTreeNodesButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-copy"
  }), _vm._v(" Copy\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default disabled",
    attrs: {
      "id": "pasteButton",
      "data-toggle": "tooltip",
      "title": "Paste selected nodes"
    },
    on: {
      "click": _vm.pasteButtonClick
    }
  }, [_c('span', {
    staticClass: "fa fa-paste"
  }), _vm._v(" Paste\n                    ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "inline",
      "margin-bottom": "0",
      "vertical-align": "bottom"
    },
    attrs: {
      "type": "text",
      "id": "treeFilterInputBox",
      "placeholder": "Tree filter"
    },
    on: {
      "keyup": _vm.treeFilterInputBoxKeyUp
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('label', {
    staticClass: "btn btn-default"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forceViewTypeId),
      expression: "forceViewTypeId"
    }],
    attrs: {
      "type": "radio",
      "name": "grp",
      "value": "-1"
    },
    domProps: {
      "checked": _vm._q(_vm.forceViewTypeId, "-1")
    },
    on: {
      "change": function($event) {
        _vm.forceViewTypeId = "-1"
      }
    }
  }), _vm._v(" Chart\n                        ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-default"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forceViewTypeId),
      expression: "forceViewTypeId"
    }],
    attrs: {
      "type": "radio",
      "name": "grp",
      "value": "4"
    },
    domProps: {
      "checked": _vm._q(_vm.forceViewTypeId, "4")
    },
    on: {
      "change": function($event) {
        _vm.forceViewTypeId = "4"
      }
    }
  }), _vm._v(" Table\n                        ")])]), _vm._v(" "), (false) ? _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Publish selected reports to dashboard"
    },
    on: {
      "click": _vm.publishToDashboard
    }
  }, [_c('span', {
    staticClass: "fa fa-wrench"
  }), _vm._v("\n                        Publish to dashboard...\n                    ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Restore Automatic Reports"
    },
    on: {
      "click": _vm.restoreAutomaticReportsClick
    }
  }, [_c('span', {
    staticClass: "fa fa-wrench"
  }), _vm._v("\n                        Restore Auto Reports\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-9",
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "id": "viewDiv"
    }
  }, [_c('div', {
    staticStyle: {
      "position": "fixed",
      "height": "76%",
      "width": "62%"
    },
    attrs: {
      "id": "chartDiv"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "62%",
      "height": "74%",
      "text-align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "left": "42%",
      "top": "42%",
      "position": "absolute"
    }
  }, [_vm._v("Loading chart...")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "left": "46%",
      "top": "50%",
      "position": "absolute"
    },
    attrs: {
      "alt": "activity indicator",
      "src": "/dist/images/ajax-loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "chartContainerDiv"
    }
  }), _vm._v(" "), _c('svg')])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('div', {
    staticClass: "reportListDiv",
    staticStyle: {
      "position": "fixed",
      "height": "76%",
      "width": "20%"
    },
    attrs: {
      "id": "reportTreeDiv"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-66cc7942", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66cc7942"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/model-reports/model-reports.vue.html
// module id = 1110
// module chunks = 0